exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-44c6339a] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\r\n\r\n\r\n", ""]);

// exports
